import { useMemo } from 'react';
import { useCurrentModule } from '../components';
import { FREE_DOMAIN_PLAN_CARD_TRANSLATION_KEY } from '../utils/consts';
import { useDomainIntent } from './useDomainIntent';
import { usePersonalizedFeatures } from './usePersonalizedFeatures';
const EMPTY_FEATURES = [];
/** The server's row, verbatim — it is the source of truth when it answers. */
const toFeature = row => {
  var _row$tooltip, _row$subItem;
  return {
    content: {
      localized: {
        translationKey: row.translation.key,
        tooltipKey: (_row$tooltip = row.tooltip) == null ? void 0 : _row$tooltip.translation.key,
        descriptionKey: (_row$subItem = row.subItem) == null ? void 0 : _row$subItem.translation.key
      }
    },
    ...(row.icon ? {
      presentation: {
        style: {
          icon: row.icon
        }
      }
    } : {})
  };
};
const withDomainFirst = features => {
  const at = features.findIndex(feature => {
    var _feature$content;
    return (feature == null || (_feature$content = feature.content) == null || (_feature$content = _feature$content.localized) == null ? void 0 : _feature$content.translationKey) === FREE_DOMAIN_PLAN_CARD_TRANSLATION_KEY;
  });
  if (at <= 0) {
    return features;
  }
  return [features[at], ...features.filter((_, i) => i !== at)];
};
export const useProductFeatures = _ref => {
  var _offering$products;
  let {
    productId
  } = _ref;
  const module = useCurrentModule();
  const {
    getFeatureRows,
    isLoading
  } = usePersonalizedFeatures();
  const {
    shouldShowDomainFirst
  } = useDomainIntent();
  const {
    data: offering
  } = module.SDK.eclipseOfferingApiClient.hooks.useFetchOffering({});
  const {
    data: product
  } = module.SDK.eclipseOfferingApiClient.hooks.useFetchProduct({
    productId
  });
  const productFamilyId = offering == null || (_offering$products = offering.products) == null || (_offering$products = _offering$products.find(p => p.productId === productId)) == null ? void 0 : _offering$products.productFamilyId;
  const rows = getFeatureRows(productFamilyId);
  const personalized = useMemo(() => rows == null ? void 0 : rows.map(toFeature), [rows]);

  // The server already pinned its rows; reordering here would double-apply.
  const ownFeatures = useMemo(() => {
    const features = (product == null ? void 0 : product.features) ?? EMPTY_FEATURES;
    return shouldShowDomainFirst && features.length ? withDomainFirst(features) : features;
  }, [product == null ? void 0 : product.features, shouldShowDomainFirst]);
  if (isLoading) {
    return {
      features: ownFeatures,
      isPersonalized: false,
      isLoading: true
    };
  }
  if (!personalized) {
    return {
      features: ownFeatures,
      isPersonalized: false,
      isLoading: false
    };
  }
  return {
    features: personalized,
    isPersonalized: true,
    isLoading: false
  };
};
//# sourceMappingURL=useProductFeatures.js.map